export default __webpack_public_path__ + "9d00cc5b3088b4b09d7d1e0f1abf0357.svg";